import { BetStateEnum } from '@app/dev/constants/enums/betState';

export const BET_OUTCOME_ONHOLD = '-5';
export const BET_OUTCOME_DECLINED = '-4';
export const BET_OUTCOME_UNSETTLED = '0';
export const BET_OUTCOME_LOST = '1';
export const BET_OUTCOME_RETURNED = '2';
export const BET_OUTCOME_WON = '3';
export const BET_OUTCOME_CASHEDOUT = '5';

export const BET_TYPE_SINGLE = '1';
export const BET_TYPE_MULTIPLE = '2';
export const BET_TYPE_SYSTEM = '3';
export const BET_TYPE_CHAIN = '4';

export const betTypes = {
  [BET_TYPE_SINGLE]: 'Single',
  [BET_TYPE_MULTIPLE]: 'Multiple',
  [BET_TYPE_SYSTEM]: 'System',
  [BET_TYPE_CHAIN]: 'Chain',
};

export const BetHistoryEnumMap = {
  [BET_OUTCOME_CASHEDOUT]: BetStateEnum.CashedOut,
  [BET_OUTCOME_WON]: BetStateEnum.Won,
  [BET_OUTCOME_RETURNED]: BetStateEnum.Returned,
  [BET_OUTCOME_LOST]: BetStateEnum.Lost,
  [BET_OUTCOME_UNSETTLED]: BetStateEnum.Accepted,
  [BET_OUTCOME_DECLINED]: BetStateEnum.Rejected,
  [BET_OUTCOME_ONHOLD]: BetStateEnum.WaitingPartner, // check keys compability
};
